import * as React from "react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {accessGroupColumns} from "utils/DataBase";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import {useEffect, useState} from "react";
import {useTheme} from "@emotion/react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import PropTypes from "prop-types";
import {getPermissionGroup, postNewPermission, updateGroupPermission, deleteGroupPermission} from 'api/Api';
import Alert, {useAlert} from "components/snacks/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import AccessGroupMember from "pages/dashboard/access_group/AccessMember";
import AccessGroupService from "pages/dashboard/access_group/AccessService";

function TablePaginationActions(props) {
    const theme = useTheme();
    const {count, page, rowsPerPage, onPageChange} = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    useEffect(() => {
        const selector = document.querySelector('#accessPagination p');
        if (selector) {
            selector.classList.add('yekan-font');
            selector.innerHTML = 'ردیف در هر صفحه';
        }
    }, []);

    return (
        <Box sx={{flexShrink: 0, ml: 2.5}}>
            <IconButton
                sx={{mr: 2.5}}
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
            </IconButton>

            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? (
                    <KeyboardArrowLeft/>
                ) : (
                    <KeyboardArrowRight/>
                )}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? (
                    <KeyboardArrowRight/>
                ) : (
                    <KeyboardArrowLeft/>
                )}
            </IconButton>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired
};

const AccessGroup = () => {
    const [currentPath, setCurrentPath] = useState('');
    const [len, setLen] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [permissions, setPermissions] = useState([]);
    const [actionModal, setActionModal] = useState({show: false, loading: false, value: ""});
    const [deleteModal, setDeleteModal] = useState({show: false, loading: false, value: ""});
    const [deletingItem, setDeletingItem] = useState({id: null, group_name: null})
    const [permissionForm, setPermissionForm] = useState({
        id: 0,
        group_name: "",
        service_access: 0,
        finance_access: 0,
        support_access: 0
    })
    const [memberModal, setMemberModal] = useState({show: false, loading: false, group_name: "", group_id: 0})
    const [serviceModal, setServiceModal] = useState({show: false, loading: false, group_name: "", group_id: 0})

    const alert_timeout = 10000;
    const alertStore = useAlert(alert_timeout);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const getPermissions = () => {
        getPermissionGroup((isOk, data) => {
            if (isOk) {
                setPermissions(data.groups);
                setLen(data.groups.length);
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data,
                    severity: 'error',
                    auto_hide: true
                });
            }
        })
    }

    useEffect(() => {
        const path = window.location.pathname;
        setCurrentPath(path);
        // ///////////////////////
        getPermissions()
    }, []);


    const setAddData = () => {
        setPermissionForm({
            id: 0,
            group_name: '',
            service_access: 0,
            finance_access: 0,
            support_access: 0
        })
        setActionModal({...actionModal, show: true, value: "add"})
    }


    const setEditData = (data) => {
        setPermissionForm({
            id: data.id,
            group_name: data.group_name,
            service_access: data.service_access,
            finance_access: data.finance_access,
            support_access: data.support_access
        })
        setActionModal({...actionModal, show: true, value: "edit"})
    }

    const setDeleteData = (data) => {
        setDeletingItem({
            id: data.id,
            group_name: data.group_name,
        })
        setDeleteModal({...deleteModal, show: true, value: "delete"})
    }

    const setMemberData = (data) => {
        setMemberModal({
            show: true,
            loading: false,
            group_name: data.group_name,
            group_id: data.id
        })
    }

    const setServiceData = (data) => {
        setServiceModal({
            show: true,
            loading: false,
            group_name: data.group_name,
            group_id: data.id
        })
    }

    const handleForm = (e) => {
        e.preventDefault();
        if (!permissionForm.group_name) {
            alertStore.AddAlert({
                key: '400',
                message: "نام را وارد کنید",
                severity: 'error',
                auto_hide: true
            });
            return false
        }
        setActionModal({
            ...actionModal,
            loading: true
        })
        const formData = new FormData();
        formData.append('group_name', permissionForm.group_name);
        formData.append('service_access', permissionForm.service_access ? '1' : '0');
        formData.append('finance_access', permissionForm.finance_access ? '1' : '0');
        formData.append('support_access', permissionForm.support_access ? '1' : '0');
        if (actionModal.value === "add") {
            postNewPermission(formData, (isOk, data) => {
                if (!isOk) {
                    alertStore.AddAlert({
                        key: '400',
                        message: data.msg,
                        severity: 'error',
                        auto_hide: true
                    });
                } else {
                    alertStore.AddAlert({
                        key: '400',
                        message: data.msg,
                        severity: 'success',
                        auto_hide: true
                    });
                    setPermissions([...permissions, data.permission_group])
                }
                setActionModal({
                    ...actionModal,
                    show: false,
                    loading: false
                })
            })
        } else {
            formData.append('group_id', permissionForm.id.toString())
            updateGroupPermission(formData, (isOk, data) => {
                if (!isOk) {
                    alertStore.AddAlert({
                        key: '400',
                        message: data.msg,
                        severity: 'error',
                        auto_hide: true
                    });
                } else {
                    alertStore.AddAlert({
                        key: '400',
                        message: data.msg,
                        severity: 'success',
                        auto_hide: true
                    });
                    getPermissions()
                }
                setActionModal({
                    ...actionModal,
                    show: false,
                    loading: false
                })
            })
        }
    }

    const handleDelete = (e) => {
        e.preventDefault();
        setDeleteModal({
            ...deleteModal,
            loading: true
        })
        deleteGroupPermission(deletingItem.id, (isOk, data) => {
            if (!isOk) {
                alertStore.AddAlert({
                    key: '400',
                    message: 'خطای سرور ...',
                    severity: 'error',
                    auto_hide: true
                });
            } else {
                alertStore.AddAlert({
                    key: '400',
                    message: data.msg,
                    severity: 'success',
                    auto_hide: true
                });
                getPermissions()
            }
            setDeleteModal({
                ...deleteModal,
                show: false,
                loading: false
            })
        })
    }

    return (
        <>
            <Paper
                id={'ticketCard'}
                elevation={1}
                sx={{overflow: 'hidden'}}
                className={`normal-shadow rounded-lg py-2 px-2 px-lg-10 py-lg-4 ${
                    currentPath === '/' ? 'mt-5 mb-lg-20 mb-10' : ''
                }`}
            >
                {currentPath === '/permission/access-group' && (
                    <div
                        className="card-header d-flex justify-content-between align-items-center py-3 gap-2 gap-md-5"
                        data-select2-id="select2-data-133-8g4r"
                    >
                        <div className="card-title">
                            <div className="d-flex align-items-center position-relative">
                                <h6 className={'m-0'}>لیست گروه دسترسی</h6>
                            </div>
                        </div>
                        <div className="" data-select2-id="select2-data-132-x8xp">
                            <buton
                                variant="contained"
                                className={'f-1 btn yekan-font btn-success btn-sm'}
                                onClick={setAddData}
                            >
                                ایجاد گروه دسترسی
                            </buton>
                        </div>
                    </div>
                )}
                <>
                    <TableContainer className="d-none d-md-block">
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead sx={{BackgroundColor: '#eaeaea'}}>
                                <TableRow>
                                    {accessGroupColumns?.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{
                                                minWidth: column.minWidth,
                                                fontFamily: 'yekan',
                                                fontSize: '1em',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {permissions &&
                                    permissions
                                        .slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        ?.map((row, index) => {
                                            return (
                                                <TableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={index}
                                                    style={{
                                                        backgroundColor:
                                                            index % 2 === 0 ? '#f3f3f3' : ''
                                                    }}
                                                >
                                                    {accessGroupColumns?.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                align={column.align}
                                                                sx={{
                                                                    fontFamily: 'yekan !important'
                                                                }}
                                                            >
                                                                {column.id === 'id' && (
                                                                    <span>{index + 1}</span>
                                                                )}
                                                                {column.id === "service_access" || column.id === "finance_access" || column.id === "support_access" ? (
                                                                    <>
                                                                        {value ?
                                                                            <i className={"bi bi-check fs-1 text-success"}></i> :
                                                                            <i className={"bi bi-x fs-1 text-danger"}></i>}
                                                                    </>
                                                                ) : <></>}
                                                                {column.id === "users" && (
                                                                    <>
                                                                        <button className={"btn btn-sm btn-"} onClick={() => setMemberData(row)}><i
                                                                            className={"bi bi-eye m-0 p-0 fs-1 text-primary"}></i>
                                                                        </button>
                                                                    </>
                                                                )}
                                                                {column.id === "services" && (
                                                                    <>
                                                                        <button className={"btn btn-sm btn-"} onClick={() => setServiceData(row)}><i
                                                                            className={"bi bi-eye m-0 p-0 fs-1 text-primary"}></i>
                                                                        </button>
                                                                    </>
                                                                )}
                                                                {column.id === "action" && (
                                                                    <>
                                                                        <button
                                                                            className={"btn btn-sm btn-warning"}
                                                                            onClick={() => setEditData(row)}
                                                                        >
                                                                            ویرایش
                                                                        </button>
                                                                        <button
                                                                            onClick={() => setDeleteData(row)}
                                                                            className={"btn btn-sm btn-danger ms-1"}>
                                                                            حذف
                                                                        </button>
                                                                    </>
                                                                )}
                                                                {column.id !== 'id' &&
                                                                    column.id !== 'service_access' &&
                                                                    column.id !== 'finance_access' &&
                                                                    column.id !== 'support_access' && (
                                                                        <span>{value}</span>
                                                                    )}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TableContainer className="d-none d-md-block">
                        <Table>
                            <TableHead/>
                            <TableBody>
                                <TableRow>
                                    <TablePagination
                                        id={'accessPagination'}
                                        rowsPerPageOptions={[
                                            5,
                                            10,
                                            25,
                                            {
                                                label: 'All',
                                                value: 1000
                                            }
                                        ]}
                                        colSpan={4}
                                        count={len}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            inputProps: {
                                                'aria-label': 'rows per page'
                                            },
                                            native: true
                                        }}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}
                                        style={{display: 'flex'}}
                                    />
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            </Paper>
            {/* ************************** ADD & UPDATE MODAL ************************** */}
            {actionModal.show && <>
                <div className="modal fade show d-block" id="submitModal">
                    <form method={"post"} onSubmit={handleForm} className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                {actionModal.value === "add" ? <h1 className="modal-title fs-5"
                                                                   id="exampleModalLabel">افزودن گروه دسترسی</h1> :
                                    <h1 className="modal-title fs-5"
                                        id="exampleModalLabel">ویرایش گروه دسترسی</h1>}

                                <button type="button" className="btn-close"
                                        onClick={() => setActionModal({
                                            ...actionModal,
                                            show: false
                                        })}></button>
                            </div>
                            {actionModal.loading ? <>
                                <div className="modal-body">
                                    <div
                                        className={"d-flex justify-content-center align-items-center"}>
                                        <Box sx={{display: 'flex', marginLeft: '15px'}}>
                                            <CircularProgress/>
                                        </Box>
                                    </div>
                                </div>
                            </> : <>
                                <div className="modal-body">
                                    <label htmlFor="service_name_modal" className={"form-label text-muted"}>نام
                                        دسترسی</label>
                                    <input type="text" className={"form-control"}
                                           placeholder={"نام دسترسی"}
                                           id={"service_name_modal"}
                                           value={permissionForm.group_name ? permissionForm.group_name : ''}
                                           onChange={(e) => setPermissionForm({
                                               ...permissionForm,
                                               group_name: e.target.value
                                           })}/>
                                    <hr/>
                                    {/* ***************** */}
                                    <div className="d-flex align-items-center mt-3">
                                        <input type="checkbox"
                                               className={"form-check"}
                                               placeholder={"دسترسی سرویس"}
                                               id={"service_access_modal"}
                                               checked={permissionForm.service_access}
                                               onChange={(e) => setPermissionForm({
                                                   ...permissionForm,
                                                   service_access: e.target.checked
                                               })}/>
                                        <label className={'form-label m-0 ms-1'} htmlFor="service_access_modal">دسترسی
                                            سرویس</label>
                                    </div>
                                    {/* ***************** */}
                                    <div className="d-flex align-items-center mt-3">
                                        <input type="checkbox"
                                               className={"form-check"}
                                               placeholder={"دسترسی مالی"}
                                               id={"finance_access_modal"}
                                               checked={permissionForm.finance_access}
                                               onChange={(e) => setPermissionForm({
                                                   ...permissionForm,
                                                   finance_access: e.target.checked
                                               })}/>
                                        <label className={'form-label m-0 ms-1'} htmlFor="finance_access_modal">دسترسی
                                            مالی</label>
                                    </div>
                                    {/* ***************** */}
                                    <div className="d-flex align-items-center mt-3">
                                        <input type="checkbox"
                                               className={"form-check"}
                                               placeholder={"دسترسی پشتیبانی"}
                                               id={"support_access_modal"}
                                               checked={permissionForm.support_access}
                                               onChange={(e) => setPermissionForm({
                                                   ...permissionForm,
                                                   support_access: e.target.checked
                                               })}/>
                                        <label className={'form-label m-0 ms-1'} htmlFor="support_access_modal">دسترسی
                                            پشتیبانی</label>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button"
                                            onClick={() => setActionModal({
                                                ...actionModal,
                                                show: false
                                            })}
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal">بستن
                                    </button>
                                    {actionModal.value === "add" ? <button type="submit"
                                                                           className="btn btn-success">افزودن
                                        </button> :
                                        <button type="submit"
                                                className="btn btn-warning">ویرایش
                                        </button>}

                                </div>
                            </>}
                        </div>
                    </form>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>}
            {/* ************************** DELETE MODAL ************************** */}
            {deleteModal.show && <>
                <div className="modal fade show d-block" id="submitModal">
                    <form method={"post"} onSubmit={handleDelete} className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5"
                                    id="exampleModalLabel">حذف گروه دسترسی</h1>
                                <button type="button" className="btn-close"
                                        onClick={() => setDeleteModal({
                                            ...deleteModal,
                                            show: false
                                        })}></button>
                            </div>
                            {deleteModal.loading ? <>
                                <div className="modal-body">
                                    <div
                                        className={"d-flex justify-content-center align-items-center"}>
                                        <Box sx={{display: 'flex', marginLeft: '15px'}}>
                                            <CircularProgress/>
                                        </Box>
                                    </div>
                                </div>
                            </> : <>
                                <div className="modal-body">
                                    <h5>
                                        <span>آیا از حذف گروه دسترسی </span>
                                        <span className={"fw-bold"}>"{deletingItem.group_name}"</span>
                                        <span> اطمینان دارید؟</span>
                                    </h5>
                                </div>
                                <div className="modal-footer">
                                    <button type="button"
                                            onClick={() => setDeleteModal({
                                                ...deleteModal,
                                                show: false
                                            })}
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal">بستن
                                    </button>
                                    <button type="submit"
                                            className="btn btn-danger">بله، حذف کن
                                    </button>
                                </div>
                            </>}
                        </div>
                    </form>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>}
            {
                memberModal.show &&
                <AccessGroupMember group_id={memberModal.group_id} group_name={memberModal.group_name}
                                   closeModal={() => setMemberModal({...memberModal, show: false})}/>
            }
            {
                serviceModal.show &&
                <AccessGroupService group_id={serviceModal.group_id} group_name={serviceModal.group_name}
                                   closeModal={() => setServiceModal({...serviceModal, show: false})}/>
            }
            {
                <Alert
                    alerts={alertStore.alert}
                    close={alertStore.RemoveAlert}
                    timeout={alert_timeout}
                />
            }
        </>
    )
}

export default AccessGroup;
